export const socialsData = {
    github: 'https://github.com/ydvrahul19',
    linkedIn: 'https://linkedin.com/in/rahul-yadav-679193190/',
    instagram: 'https://instagram.com/iiknowyoouknowme',
    twitter: 'https://x.com/ydvrahul19',
    medium: '',
    blogger: '',
    youtube: '',
    reddit: '',
    stackOverflow: '',
    codepen: '',
    gitlab: ''
};
